import AllHospital from "./hospital/AllHospital";

export default function HospitalView(){
    return <div>
        <AllHospital />
    </div>
}